export default {
  'Carolina Hurricanes': {
    displayName: 'CAR Hurricanes',
    logoUrl: 'nhl/carolina_hurricanes.webp',
  },
  'Boston Bruins': {
    displayName: 'BOS Bruins',
    logoUrl: 'nhl/boston_bruins.webp',
  },
  'Columbus Blue Jackets': {
    displayName: 'CBJ Blue Jackets',
    logoUrl: 'nhl/columbus_blue_jackets.webp',
  },
  'Buffalo Sabres': {
    displayName: 'BUF Sabres',
    logoUrl: 'nhl/buffalo_sabres.webp',
  },
  'New Jersey Devils': {
    displayName: 'NJD Devils',
    logoUrl: 'nhl/new_jersey_devils.webp',
  },
  'Detroit Red Wings': {
    displayName: 'DET Red Wings',
    logoUrl: 'nhl/detroit_red_wings.webp',
  },
  'New York Islanders': {
    displayName: 'NYI Islanders',
    logoUrl: 'nhl/new_york_islanders.webp',
  },
  'Florida Panthers': {
    displayName: 'FLA Panthers',
    logoUrl: 'nhl/florida_panthers.webp',
  },
  'New York Rangers': {
    displayName: 'NYR Rangers',
    logoUrl: 'nhl/new_york_rangers.webp',
  },
  'Montreal Canadiens': {
    displayName: 'MTL Canadiens',
    logoUrl: 'nhl/montreal_canadiens.webp',
  },
  'Philadelphia Flyers': {
    displayName: 'PHI Flyers',
    logoUrl: 'nhl/philadelphia_flyers.webp',
  },
  'Ottawa Senators': {
    displayName: 'OTT Senators',
    logoUrl: 'nhl/ottawa_senators.webp',
  },
  'Pittsburgh Penguins': {
    displayName: 'PIT Penguins',
    logoUrl: 'nhl/pittsburgh_penguins.webp',
  },
  'Tampa Bay Lightning': {
    displayName: 'TBL Lightning',
    logoUrl: 'nhl/tampa_bay_lightning.webp',
  },
  'Washington Capitals': {
    displayName: 'WAS Capitals',
    logoUrl: 'nhl/washington_capitals.webp',
  },
  'Toronto Maple Leafs': {
    displayName: 'TOR Maple Leafs',
    logoUrl: 'nhl/toronto_maple_leafs.webp',
  },
  'Chicago Blackhawks': {
    displayName: 'CHI Blackhawks',
    logoUrl: 'nhl/chicago_blackhawks.webp',
  },
  'Anaheim Ducks': {
    displayName: 'ANA Ducks',
    logoUrl: 'nhl/anaheim_ducks.webp',
  },
  'Colorado Avalanche': {
    displayName: 'COL Avalanche',
    logoUrl: 'nhl/colorado_avalanche.webp',
  },
  'Calgary Flames': {
    displayName: 'CGY Flames',
    logoUrl: 'nhl/calgary_flames.webp',
  },
  'Dallas Stars': {
    displayName: 'DAL Stars',
    logoUrl: 'nhl/dallas_stars.webp',
  },
  'Edmonton Oilers': {
    displayName: 'EDM Oilers',
    logoUrl: 'nhl/edmonton_oilers.webp',
  },
  'Minnesota Wild': {
    displayName: 'MIN Wild',
    logoUrl: 'nhl/minnesota_wild.webp',
  },
  'Los Angeles Kings': {
    displayName: 'LAK Kings',
    logoUrl: 'nhl/los_angeles_kings.webp',
  },
  'Nashville Predators': {
    displayName: 'NSH Predators',
    logoUrl: 'nhl/nashville_predators.webp',
  },
  'San Jose Sharks': {
    displayName: 'SJS Sharks',
    logoUrl: 'nhl/san_jose_sharks.webp',
  },
  'St. Louis Blues': {
    displayName: 'STL Blues',
    logoUrl: 'nhl/st_louis_blues.webp',
  },
  'Seattle Kraken': {
    displayName: 'SEA Kraken',
    logoUrl: 'nhl/seattle_kraken.webp',
  },
  'Utah Mammoth': {
    displayName: 'UTA Mammoth',
    logoUrl: 'nhl/utah_mammoth.webp',
  },
  'Vancouver Canucks': {
    displayName: 'VAN Canucks',
    logoUrl: 'nhl/vancouver_canucks.webp',
  },
  'Winnipeg Jets': {
    displayName: 'WPG Jets',
    logoUrl: 'nhl/winnipeg_jets.webp',
  },
  'Vegas Golden Knights': {
    displayName: 'VGK Golden Knights',
    logoUrl: 'nhl/vegas_golden_knights.webp',
  },
};
